<template>
	<div
		style="margin: 10px;">
    <v-card
			color="primary"
      class="mx-auto mt-5"
      style="margin-bottom: 50px;"
      max-width="750">
      <v-layout
        column
        fill-height>
        <v-card-title class="white--text pl-5 pt-5">
          <p>Messages</p><v-spacer/>

					<div>
	          <composeMessageModal />
	          <v-btn icon @click='fetchMessage()'>
	            <v-icon color='white' title='refresh the list' >refresh</v-icon>
	          </v-btn>
					</div>
        </v-card-title>
      </v-layout>
      <v-tabs v-model='tab'>
        <v-tab href="#tab-1">Inbox</v-tab>
        <v-tab href="#tab-2">Sent Messages</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          :value="'tab-1'">
          <v-card flat>
            <v-card-text>
              <v-list
                two-line>
                <center
                v-if="inboxMessages.length === 0">
                You have no messages at this time.
                </center>
                <v-list-item
                  :key='index'
                  v-for='(message,index) in inboxMessages'
                  @click='initMessage(message)' >
                  <v-list-item-action>
                    <!-- redundant? -->
                    <v-icon color="primary" v-if='!readByUser(message)'>mdi-email</v-icon>
                    <v-icon color="primary" v-else>mdi-email-open</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{message.title}}</v-list-item-title>
                    <v-list-item-subtitle>Last message sent on {{message.messageThread[message.messageThread.length -1].createdAt}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item
          :value="'tab-2'">
          <v-card flat>
            <v-card-text>
              <v-list
                two-line>
                <center
                  v-if="sentMessages.length === 0">
                  You haven't sent any messages yet.
                </center>
                <v-list-item
                  :key='index'
                  v-for='(message,index) in sentMessages'
                  @click='currentMessage = message; messageDialog = true'>
                  <v-list-item-action>
                    <v-icon color="primary">mdi-email-open</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{message.title}}</v-list-item-title>
                    <v-list-item-subtitle>Last message sent on {{message.messageThread[message.messageThread.length -1].createdAt}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <v-banner
    single-line
  >
    *If you have an urgent medical question or concern, please contact your doctor or dial 9-1-1.
  </v-banner>
    </v-card>

	  <v-dialog
	    v-model="messageDialog"
	    max-width='1000'
	    scrollable>
	    <v-card v-if='currentMessage'>
	      <v-toolbar dense>
	        <v-toolbar-title v-if='currentMessage.messageType === "non-system"'>Message</v-toolbar-title>
	        <v-spacer></v-spacer>
	      </v-toolbar>

	      <v-card-title class="headline">{{currentMessage.title}}</v-card-title>

	      <v-card-text>
					<div
						v-if="this.$vuetify.breakpoint.name === 'xs'">
						<v-card
							style="margin-bottom:5px;"
							:class="computeColor(n.message_to.email)"
							v-for="(n,index) in currentMessage.messageThread"
							:key="index">
							<v-card-text>
								{{n.message_from.email}}
							</v-card-text>
							<v-card-text>
								{{n.messageBody}}
							</v-card-text>
						</v-card>
					</div>
	        <v-timeline
						v-else
	          dense>
	          <v-timeline-item
	            :icon="computeIcon(n.message_to.email)"
	            v-for="(n,index) in currentMessage.messageThread"
	            :key="index">
	            <span slot="opposite">From : {{n.message_from.email}}</span>
	            <v-card :class="computeColor(n.message_to.email)">
	              <v-card-text>
	                <v-icon class="float-left">chat</v-icon>
	                <span class="float-left" >{{n.message_from.email}}</span>
	                <!-- <span class="float-right" >{{n.createdAt}}</span> -->
	                <br/>
	                <div class='mt-5'></div>
	                {{n.messageBody}}
	              </v-card-text>
	            </v-card>
	          </v-timeline-item>
	        </v-timeline>
	        <br/>
	        <v-textarea
	          class='pt-5'
	          v-model='replyMessage'
	          outlined
	          name="input-7-4"
	          label="Reply Message Here">
            </v-textarea>
            <fileUploader />
	      </v-card-text>

	      <v-card-actions>
	        <v-spacer></v-spacer>
	        <v-btn
	          color="green darken-1"
	          text
	          :disabled='replyMessage === null || replyMessage === ""'
	          @click="sendReply">Reply</v-btn>
	        <v-btn
	          color="green darken-1"
	          text
	          @click="messageDialog = false">Close</v-btn>
	      </v-card-actions>
	    </v-card>
	  </v-dialog>
	</div>
</template>

<script>
import fileUploader from "../components/Upload"
import composeMessageModal from "../components/message/composeMessageModal"
import { mapFields } from 'vuex-map-fields';
import { getMessage, updateLastRead, replyMessage, getMessageByUID } from '../helper/firestore'


export default {
  data () {
    return {
      selectedDocumentType : "attachFile",
      theFile : null,
      inboxMessages : [],
      sentMessages : [],
      replyMessage : null,
      sortedMessages : [],
      currentMessage : null,
      messageDialog : false,
      tab : null,
    }
  },
  mounted () {
    this.fetchMessage();
  },
  components: {
    composeMessageModal,fileUploader
  },
  methods: {
    mostRecentToUserID(thread) {
      var messagesToUser = thread.messageThread.filter((message) => {
        return message.message_to.email === this.user.email
      })
      if (messagesToUser.length > 0) {
        return messagesToUser[messagesToUser.length-1].messageID
      } else {
        return 0
      }
    },
    userRead(thread) {
      let temp = {...thread}
      // get messages that were to user
      let msgArray = temp.messageThread.filter(message => {
        return message.message_to.email === this.user.email
      });
      if (msgArray.length > 0) {
        let mostRecent = msgArray[msgArray.length - 1]
        let changeIndex = thread.messageThread.findIndex((msg) => {
          return msg.messageID === mostRecent.messageID
        })
        thread.messageThread[changeIndex].read = true
      }
      return thread
    },
    readByUser(thread) {
      var msgs_to_user = thread.messageThread.filter(message => {return message.message_to.email === this.user.email})
      return msgs_to_user[msgs_to_user.length - 1].read;
    },
    computeIcon(to_email){
      let iconClass = to_email === this.user.email ? "supervisor_account" : "person"
      return iconClass
    },
    computeColor(to_email){
      let cardClassName = to_email === this.user.email ? "elevation-2" : "grey lighten-3 elevation-2"
      return cardClassName
    },
    sendReply(){
			var to_email = this.currentMessage.message_from.email === this.user.email ? this.currentMessage.message_to.email : this.currentMessage.message_from.email
      var replyMessageThread = {
        message_to:{
					email: to_email,
          uid: null
        },
        message_from:{
          email: this.user.email,
          uid: this.user.uid
        },
        read: false,
        createdAt: null,
        messageBody:this.replyMessage,
        messageID:null
      }
      replyMessage({
          messageID : this.currentMessage.messageID,
          messageBody : replyMessageThread
        }, () => {
          this.replyMessage = null
          this.fetchMessage();
      })
      this.messageDialog = false
    },
    fetchMessage() {
      let compare = function(a, b) {
        var str_timeA = a.messageThread[a.messageThread.length - 1].createdAt
          .replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})/, (match, p1, p2, p3, p4, off, str) => {
            return p3+"-"+p1+"-"+p2+"T"+p4
          })
        var str_timeB = b.messageThread[b.messageThread.length - 1].createdAt
          .replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})/, (match, p1, p2, p3, p4, off, str) => {
            return p3+"-"+p1+"-"+p2+"T"+p4
          })
        var timeA = Date.parse(str_timeA)
        var timeB = Date.parse(str_timeB)
        let comparison = 0;
        if (timeA < timeB) {
          comparison = 1;
        } else if (timeA > timeB) {
          comparison = -1;
        }
        return comparison;
      }
      getMessage((response) => {
        let messages = response.data
        this.inboxMessages = messages.filter((thread) => {
            let msgs = thread.messageThread
            return msgs[msgs.length-1].message_to.email === this.user.email
        }).sort(compare)
        this.sentMessages = messages.filter((thread) => {
            let msgs = thread.messageThread
            return msgs[msgs.length-1].message_to.email !== this.user.email
        }).sort(compare)
      })
    },
    initMessage(item) {
      //mark message as read
      item = this.userRead(item);
      let itemIndex = this.inboxMessages.findIndex((thread) => {
        return thread.messageID === item.messageID;
      });
      this.inboxMessages[itemIndex] = item;
      //send post req to end point to mark message as read
      updateLastRead(item.messageID, this.mostRecentToUserID(item), () => {
      })
      this.currentMessage = item
      this.messageDialog = true
    },
    reformatTime(timeString) {
      return new Date(timeString).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour12: true, hour: 'numeric', minute: 'numeric'});
    }
  },
  computed: {
    ...mapFields([
      'messages',
      'messagesCount',
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
      'overlay',
      'isPublic'
    ]),
  },
}
</script>
<style scoped>

</style>
